// extracted by mini-css-extract-plugin
export default {"root":"ResetPassword_root__A7f4Q","title":"ResetPassword_title__Xh1HR","form":"ResetPassword_form__EoN1T","button":"ResetPassword_button__8LaUn","link":"ResetPassword_link__FW6KI"};